var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.vueAppClasses,attrs:{"id":"app"}},[_c('router-view',{directives:[{name:"show",rawName:"v-show",value:(_vm.showApp),expression:"showApp"}],on:{"setAppClasses":_vm.setAppClasses}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }